import { defineRouting } from 'next-intl/routing';

export const routing = defineRouting({
  locales: ['en', 'ru', 'ro'],
  defaultLocale: 'en',
  localeCookie: {
    name: 'locale',
    maxAge: 60 * 60 * 24 * 365,
    path: '/',
    secure: true,
    sameSite: 'lax'
  },
  localePrefix: {
    mode: 'as-needed'
  },
  pathnames: {
    '/': '/',
    '/programs': {
      ru: '/программы',
      en: '/programs',
      ro: '/programe'
    },
    '/services': {
      ru: '/услуги',
      en: '/services',
      ro: '/servicii'
    },
    '/about': {
      ru: '/о-нас',
      en: '/about',
      ro: '/despre-noi'
    }
  }
});
